import { render, staticRenderFns } from "./ExclusionView.vue?vue&type=template&id=2a52988d&"
import script from "./ExclusionView.vue?vue&type=script&lang=js&"
export * from "./ExclusionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QBtn})
